<template>
  <div class="participant-item">
    <div v-if="!isMobileApp" class="divider"></div>
    <div v-if="!isMobileApp" class="participants__menu">
      <Menu />
      <div class="divider"></div>
    </div>
    <div class="participant-item__wrapper">
      <div class="participant-item__card">
        <div v-if="!isMobileApp" class="participant-item__card-prev">
          <Button
            variant="secondary"
            :size="$root.isMobile ? 'sm' : 'lg'"
            shape="circle"
            iconLeft="left"
            mobile
            @click="pagePrev"
          ></Button>
        </div>
        <div v-if="!isMobileApp" class="participant-item__card-upload">
          <Button
            variant="secondary"
            :size="$root.isMobile ? 'sm' : 'lg'"
            shape="circle"
            iconLeft="upload"
            mobile
            id="menuButton"
          ></Button>
          <Dropdown
            triggerId="menuButton"
            placement="bottom"
            listeners="click"
            hide-overlay
            auto-width
          >
            <template slot="items">
              <div class="base-dropdown__item participant__dropdown participant__dropdown--links">
                <p class="participant__dropdown-title">Поделиться</p>
                <div @click="copyUrlToClipboard" class="participant__dropdown-item participant__dropdown-item--one">
                  <span class="participant__dropdown-link">
                    <span>Скопировать ссылку</span>
                    <Icon name="copy" size="xs" />
                  </span>
                </div>
              </div>
            </template>
          </Dropdown>
        </div>

        <div v-if="participantData" class="participant-item__card-header">
          <div class="participant-item__card-img">
            <div class="participant-item__card-avatar" :style="{ 'background-image': `url(${getAvatarImage(participantData.avatar)})`, 'background-color': participantData.avatar ? '#c7c0c0' : ''}">
            </div>
            <div class="participant-item__card-level">{{ participantData.level || 0 }} ур.</div>
          </div>
          <div v-if="participantData.firstName || participantData.lastName" class="participant-item__card-info">
            <p class="participant-item__card-name">{{ participantData.firstName || '' }} {{ participantData.lastName || '' }}</p>
            <div class="participant-item__card-row">
              <div
                v-if="showGenderOrAge && participantData.gender"
                :class="{'male' : participantData.gender === 'Male', 'female' : participantData.gender === 'Female'}"
              >
                <Icon v-if="participantData.gender === 'Male'" name="male" size="xxs" />
                <Icon v-if="participantData.gender === 'Female'" name="female" size="xxs" />
              </div>
              <p v-if="showGenderOrAge && participantData.birthday" class="participant-item__card-age">{{ calculateAge(participantData.birthday) }}</p>
              <p
                v-if="participantData.city"
                :class="['participant-item__card-city', { 'participant-item__card-city--with-dot': showGenderOrAge }]"
              >
                {{ participantData.city }}
              </p>
            </div>
            <div class="participant-item__card-team">
              <div class="participant-item__card-team-avatar" >
                <img
                  v-if="participantData.teams && participantData.teams.length > 0 && participantData.teams[0].logo"
                  :src="participantData.teams[0].logo"
                  alt=""
                />
                <Icon v-else name="user" size="xs" />
              </div>
              <p
                :class="{ team: participantData.teams && participantData.teams.length > 0 && participantData.teams[0].logo }"
                class="participant-item__card-team-title"
              >
                {{ participantAccounts.teamName }}
              </p>
            </div>
            <Button
              v-if="participantAccounts.vk || participantAccounts.telegram"
              variant="secondary"
              size="lg"
              tag="a"
              mobile
              :href="participantAccounts.vk ? participantAccounts.vk : `https://t.me/${participantAccounts.telegram}`"
              target="_blank"
              wide
              :iconLeft="iconButton"
              text="Написать сообщение"
              id="showLevelInfo"
            />
            <Dropdown
              v-if="participantAccounts.vk && participantAccounts.telegram"
              triggerId="showLevelInfo"
              :placement="'top'"
              listeners="click"
              hide-overlay
              auto-width
            >
              <template slot="items">
                <div class="base-dropdown__item participant__dropdown">
                  <p class="participant__dropdown-title">Написать участнику</p>
                  <ul class="participant__dropdown-list">
                    <li v-if="participantAccounts.vk" class="participant__dropdown-item" :class="{ 'participant__dropdown-item--one': !participantAccounts.telegram }">
                      <a :href="participantAccounts.vk" target="_blank" class="participant__dropdown-link">
                        <span>Вконтакте</span>
                        <Icon name="vk" size="m" />
                      </a>
                    </li>
                    <li v-if="participantAccounts.telegram" class="participant__dropdown-item" :class="{ 'participant__dropdown-item--one': !participantAccounts.vk }">
                      <a :href="`https://t.me/${participantAccounts.telegram}`" target="_blank" class="participant__dropdown-link">
                        <span>Telegram</span>
                        <Icon name="telegram" size="m" />
                      </a>
                    </li>
                  </ul>
                </div>
              </template>
            </Dropdown>
          </div>
        </div>
        <Tabs
          class="participant-item__tabs"
          :items="tabs"
          :activeItem="selectedTab"
          @changed="onChangeTab"
        />
        <div class="participant-item__content">
          <div v-if="isVisible(0)">
            <div class="activity" id="dashboard-activity">
              <div class="activity__loader" v-if="loading || activitySliderHidden">
                <Loader size="24" />
              </div>
              <div
                class="activity__slider"
                v-if="activitySliderVisible"
                :class="{ 'activity__slider--hidden': activitySliderHidden }"
              >
                <Slider
                  v-if="!loading && activities && activities.length > 0"
                  cols="1"
                  :navigationOffset="activityNavigationOffset"
                  :paginationOffset="activityPaginationOffset"
                  :slidesPerView="1"
                  :autoHeight="true"
                  class="activity-slider"
                  @indexChanged="onSliderIndexChaged"
                >
                  <ActivityCard
                    v-for="(activity, i) in activities"
                    :key="i"
                    :title="activity.date"
                    :items="activity.items"
                  ></ActivityCard>
                </Slider>
              </div>
            </div>
          </div>

          <div v-if="isVisible(1)">
            <div class="nominations">
              <div class="activity__loader" v-if="loading || ratingSliderHidden">
                <Loader size="24" />
              </div>
              <template v-if="!loading">
                <div
                  v-if="showNominationToggle && ratingSliderVisible && !ratingSliderHidden"
                  class="nominations__types"
                >
                  <Button
                    v-for="(item, i) in nominationTypes"
                    :key="i"
                    :variant="i === selectedNominationType ? 'primary' : 'secondary'"
                    :disabled="isRatingTypeDisabled(i)"
                    size="md"
                    mobile
                    @click="onChangeNominationType(i)"
                  >
                    {{ item }}
                  </Button>
                </div>
                <div
                  class="nominations__slider-container"
                  :class="{
                    'nominations__slider-container--hidden': ratingSliderHidden,
                    'nominations__slider-container--switching': nominationTypeSwitching,
                  }"
                  :style="nominationTypeSwitching && nominationsSwitchMinHeight ? { minHeight: nominationsSwitchMinHeight + 'px' } : undefined"
                  :id="nominationsSliderId"
                >
                  <div
                    v-if="ratingSliderVisible && currentRatingsList.length > 0"
                    class="nominations__slider"
                    :class="{ 'nominations__slider--team': selectedNominationType === 1 }"
                  >
                    <Slider
                      :key="'rating-' + selectedNominationType"
                      cols="1"
                      :slidesPerView="1"
                      :loop="true"
                      :autoHeight="selectedNominationType === 1"
                      :navigationOffset="nominationsNavigationOffset"
                      :paginationOffset="nominationsPaginationOffset"
                      :filterByGroupId="selectedNominationType === 1 ? '1' : undefined"
                      class="nominations-slider"
                    >
                      <NominationCard
                        v-for="item in currentRatingsList"
                        :key="item.nominationId"
                        type="personal"
                        :state="selectedNominationType === 1 ? 'in-progress' : nominationsState"
                        :image="getNominationImage(item)"
                        :nominationText="getNominationDates(item)"
                        :lockedText="{ text: 'Для участия необходимо', link: 'подключить трекер' }"
                        :title="item.title"
                        :rules="{ text: 'Правила', action: () => onShowRules(item) }"
                        :prizes="{ text: 'Награды', action: () => onShowPrizes(item) }"
                        :ratingText="selectedNominationType === 1 ? { general: 'Текущий рейтинг', personal: 'Команда в рейтинге' } : { general: 'Текущий рейтинг', personal: 'Вы в рейтинге' }"
                        :values="getNominationRating(item, selectedNominationType === 1)"
                        :class="{ 'team-rating': selectedNominationType === 1 }"
                        data-group-id="1"
                        @show-details="onShowRating(item, selectedNominationType === 1)"
                        @locked-click="onShowOnboarding()"
                      />
                    </Slider>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div v-if="isVisible(2)">
            <div class="activity__loader" v-if="loading">
              <Loader size="24" />
            </div>
            <div v-else>
              <div class="participant-item__achievements">
                <AchievementsParticipant
                  :achievements="participantAchievements"
                  :isMobileApp="isMobileApp"
                  :sportIndexes="participantSportIndexes"
                  :steps="participantSteps"
                />
              </div>
            <div v-if="statistics" class="participant-item__activities">
              <Metric
                v-for="(item, i) in statistics"
                :key="i"
                :icon="item.icon"
                :value="item.value"
                :subtitle="item.subtitle"
              />
              </div>
              <div class="participant-item__graph">
                <div class="goal__compare">
                  <div class="compare__text" v-html="distanceText"></div>
                  <div class="compare__text" v-html="compareText"></div>
                  <div
                    class="compare__graph"
                    :style="{ 'background-image': `url('${ $root.isMobile ? goalGraphMobile : goalGraph }')` }"
                  >
                    <img
                      :src="goalTriangle"
                      class="graph__marker"
                      :style="{
                        'left': `calc(${ Math.round((participantDistance && participantDistance.contributionPercentage) ? participantDistance.contributionPercentage : 0)-1 }%)`,
                        'bottom': `calc(${ goalCoords[Math.round((participantDistance && participantDistance.contributionPercentage) ? participantDistance.contributionPercentage : 0)] }px + 8px)`,
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RulesPrizesModal
      :active="rulesPrizesModal"
      :image="rulesPrizesImage"
      :title="rulesPrizesTitle"
      :subtitle="rulesPrizesSubtitle"
      :nominationId="rulesPrizesNominationId"
      :isTeam="rulesPrizesIsTeam"
      state="personal"
      :tabs="rulesPrizesTabs"
      :activeTab="rulesPrizesTabActive"
      :isMobileApp="isMobileApp"
      @close="onRulesPrizesClosed"
    />

    <Modal
      :closable="true"
      name="paticipantModal"
      title="Написать участнику"
      :active="paticipantModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="onParticipantModalClose"
    >
      <ul class="participant__dropdown-list">
        <li class="participant__dropdown-item">
          <a :href="accounts ? accounts.vk : ''" target="_blank" class="participant__dropdown-link">
            <span>Вконтакте</span>
            <Icon name="vk" size="xs" />
          </a>
        </li>
        <li class="participant__dropdown-item">
          <a :href="`https://t.me/${accounts ? accounts.telegram : ''}`" target="_blank" class="participant__dropdown-link">
            <span>Telegram</span>
            <Icon name="telegram" size="xs" />
          </a>
        </li>
      </ul>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import NominationCard from '@sc-component-library/nomination-card/src/main';
import Metric from '@rr-component-library/metric/src/main';
import Menu from '@/components/Menu/Menu.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import Avatars from '@/assets/data/avatars';
import ActivityCard from '@/components/ActivityCard/ActivityCard.vue';
import ActivityCover3 from '@/assets/img/activity-card/updated.svg';
import ActivityCoverXP from '@/assets/img/activity-card/xp.svg';
import TrainingRun from '@/assets/icons/training-run.svg';
import TrainingWalk from '@/assets/icons/training-walk.svg';
import TrainingCycling from '@/assets/icons/training-cycling.svg';
import TrainingSwim from '@/assets/icons/training-swim.svg';
import TrainingSki from '@/assets/icons/training-ski.svg';
import TrainingDancing from '@/assets/icons/training-dancing.svg';
import TrainingFitness from '@/assets/icons/training-fitness.svg';
import TrainingStrength from '@/assets/icons/training-strength.svg';
import TrainingMartialArts from '@/assets/icons/training-martial-arts.svg';
import TrainingPlaying from '@/assets/icons/training-playing.svg';
import TrainingExtreme from '@/assets/icons/training-extreme.svg';
import TrainingOutdoor from '@/assets/icons/training-outdoor.svg';
import RulesPrizesModal from '@/components/RulesPrizesModal/RulesPrizesModal.vue';
import AchievementsParticipant from '@/components/AchievementsParticipant/AchievementsParticipant.vue';

import GoalCoords from '@/assets/data/goalCoords';
import {
  scrollToId, addNonBreakingSpaces, formatDateRange, formatNumber,
} from '@/assets/js/helpers';

export default {
  name: 'ParticipantItem',
  components: {
    Menu,
    Dropdown,
    ActivityCard,
    NominationCard,
    RulesPrizesModal,
    AchievementsParticipant,
    Metric,
  },
  data() {
    return {
      goalCoords: GoalCoords,
      selectedTab: 0,
      participantData: {},
      participantId: '',
      activities: null,
      activitySliderVisible: false,
      activitySliderHidden: true,
      ratingSliderVisible: false,
      ratingSliderHidden: true,
      loading: true,
      tabs: [
        { title: 'Активность', enabled: true },
        { title: 'Рейтинги', enabled: true },
        { title: 'Статистика', enabled: true },
      ],
      url: window.location.href,
      nominationsSliderId: `nominations__slider-container${Math.random().toString().replace('.', '')}`,
      selectedNominationType: null,
      nominationTypes: ['Личный', 'Командный'],
      nominationTypeSwitching: false,
      nominationsSwitchMinHeight: 0,
      nominationsState: 'in-progress',
      rulesPrizesModal: false,
      rulesPrizesImage: '',
      rulesPrizesTitle: '',
      rulesPrizesSubtitle: '',
      rulesPrizesNominationId: '',
      rulesPrizesIsTeam: false,
      rulesPrizesTabActive: 0,
      statistics: [],
      paticipantModal: false,
      accounts: null,
      rulesPrizesTabs: [
        {
          title: 'Правила',
          enabled: true,
          content: '',
        },
        {
          title: 'Награды',
          enabled: true,
          content: '',
        },
        {
          title: 'Рейтинг',
          enabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isMobileApp', 'profile']),
    isTeamSet() {
      return this.profile && Array.isArray(this.profile.teams) && this.profile.teams.length > 0;
    },
    ...mapGetters('settings', ['theme', 'themeDone', 'options', 'resources']),
    ...mapGetters('communications', ['participant', 'participantOperationshistory', 'participantRatings', 'participantTeamRatings', 'participantStatistics', 'participantSteps', 'participantSportIndexes', 'participantDistance']),
    ...mapGetters('achievements', ['participantAchievements']),
    ...mapGetters('trainings', ['sportIndexes']),
    participantAccounts() {
      const vk = this.participant && this.participant.accounts ? this.participant.accounts.vk : '';
      const telegram = this.participant && this.participant.accounts ? this.participant.accounts.telegram : '';

      let teamName = 'Без команды';
      if (this.participant) {
        if (Array.isArray(this.participant.teams) && this.participant.teams.length > 0) {
          teamName = this.participant.teams[0].name || teamName;
        } else if (this.participant.team && this.participant.team.name) {
          // fallback для старого формата с одиночной командой
          teamName = this.participant.team.name;
        }
      }
      return { vk, telegram, teamName };
    },
    iconButton() {
      if (this.participantAccounts.vk && this.participantAccounts.telegram) {
        return 'chat-bubble';
      }
      if (this.participantAccounts.vk) {
        return 'vk';
      }
      if (this.participantAccounts.telegram) {
        return 'telegram';
      }
      return '';
    },
    activityNavigationOffset() {
      return {
        default: '0', md: '0', lg: '0', xl: '1',
      };
    },
    activityPaginationOffset() {
      return {
        default: '8', md: '12', lg: '12', xl: '28',
      };
    },
    nominationsNavigationOffset() {
      return {
        default: '0', md: '0', lg: '0', xl: '10',
      };
    },
    nominationsPaginationOffset() {
      return {
        default: '0', md: '4', lg: '4', xl: '12',
      };
    },
    hasPersonalRatings() {
      return Array.isArray(this.participantRatings) && this.participantRatings.length > 0;
    },
    hasTeamRatings() {
      return Array.isArray(this.participantTeamRatings)
        && this.participantTeamRatings.length > 0;
    },
    showNominationToggle() {
      return this.hasPersonalRatings && this.hasTeamRatings;
    },
    currentRatingsList() {
      if (this.selectedNominationType === 1) {
        return Array.isArray(this.participantTeamRatings) ? this.participantTeamRatings : [];
      }
      return Array.isArray(this.participantRatings) ? this.participantRatings : [];
    },
    goalGraph() {
      return this.resources ? this.resources.goalGraph || '' : '';
    },
    goalGraphMobile() {
      return this.resources ? this.resources.goalGraphMobile || '' : '';
    },
    goalTriangle() {
      return this.resources ? this.resources.goalTriangle || '' : '';
    },
    compareText() {
      return addNonBreakingSpaces(`Вклад больше, чем у <span class="participant-item__text">${formatNumber(Math.round(this.participantDistance ? this.participantDistance.contributionPercentage : 0), '%')}</span> участников`);
    },
    distanceText() {
      return addNonBreakingSpaces(`Вклад в общую цель: <span>${formatNumber(this.participantDistance ? this.participantDistance.totalDistance : 0, 'км')}.</span>`);
    },
    hideParticipantsGenderAge() {
      return this.options ? this.options.hideParticipantsGenderAge === true : false;
    },
    showGenderOrAge() {
      if (this.hideParticipantsGenderAge) return false;
      if (!this.participantData) return false;
      return !!(this.participantData.gender || this.participantData.birthday);
    },
  },
  methods: {
    ...mapActions('user', ['getProfile']),
    ...mapActions('wallet', ['getBalance']),
    ...mapActions('communications', ['getParticipant', 'getActivityOperations', 'getParticipantRatings', 'getParticipantTeamRatings', 'getParticipantStatistic', 'getParticipantSteps', 'getParticipantSportIndex', 'getParticipantDistance']),
    ...mapActions('achievements', ['getParticipantAchievements']),
    ...mapActions('trainings', ['getIndexes']),
    onHashChange() {
      if (this.$route.name !== 'ParticipantItem') {
        window.removeEventListener('hashchange', this.onHashChange);
        return;
      }
      const hash = window.location.hash.split('=');
      if (hash[0] === '#!showNomination') this.showNomination(hash);
      else if (hash[0] === '#!showParticipant') this.showParticipant(hash);
      else {
        this.rulesPrizesModal = false;
        this.paticipantModal = false;
      }
    },
    onParticipantModal(participant) {
      window.location.hash = '#!showParticipant=true';
      this.accounts = participant.accounts;
    },
    onParticipantModalClose() {
      window.location.hash = '#!showParticipant=false';
    },
    getTrainingIcon(discipline) {
      if (discipline === 'Running') return TrainingRun;
      if (discipline === 'Walking') return TrainingWalk;
      if (discipline === 'Cycling') return TrainingCycling;
      if (discipline === 'Swimming') return TrainingSwim;
      if (discipline === 'Skiing') return TrainingSki;
      if (discipline === 'Dancing') return TrainingDancing;
      if (discipline === 'Fitness') return TrainingFitness;
      if (discipline === 'Strength') return TrainingStrength;
      if (discipline === 'MartialArts') return TrainingMartialArts;
      if (discipline === 'Playing') return TrainingPlaying;
      if (discipline === 'Extreme') return TrainingExtreme;
      if (discipline === 'Outdoor') return TrainingOutdoor;
      return ActivityCover3; // fallback
    },
    getFormattedSportActivityTitle(value, trainingsLink = '/my-settings/trainings') {
      if (!value || !value.attributes) return '';
      const { attributes } = value;
      const discipline = attributes.Discipline || '';
      const distance = attributes.Distance ? parseInt(attributes.Distance, 10) : null;
      const timeInSeconds = attributes.TimeInSeconds ? parseInt(attributes.TimeInSeconds, 10) : 0;
      const calories = attributes.Calories ?? attributes.calories;
      const hasCalories = calories !== undefined && calories !== null && Number(calories) > 0;

      const rawPulse = attributes.Pulse;
      const parsedPulse = rawPulse !== undefined && rawPulse !== null && rawPulse !== ''
        ? Number(rawPulse)
        : NaN;
      const hasPulse = Number.isFinite(parsedPulse) && parsedPulse > 0;

      // Форматирование расстояния
      let distanceText = '';
      if (distance !== null && distance > 0) {
        const unit = distance >= 1000 ? 'км' : 'м';
        let formatted = '';
        if (distance >= 1000) {
          formatted = (distance / 1000).toFixed(2);
          if (formatted[formatted.length - 1] === '0') formatted = formatted.slice(0, formatted.length - 1);
          if (formatted.indexOf('.0') >= 0) formatted = formatted.slice(0, formatted.indexOf('.0'));
          formatted = formatted.replace('.', ',');
        } else {
          formatted = distance.toString();
        }
        distanceText = `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${formatted} ${unit}</a>`;
      }

      // Форматирование времени
      let durationText = '';
      if (timeInSeconds > 0) {
        const minutes = Math.floor(timeInSeconds / 60);
        durationText = `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${minutes} мин</a>`;
      }

      // Калории или пульс: при наличии калорий показываем их, иначе — пульс
      const caloriesText = hasCalories
        ? `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${Number(calories)} ккал</a>`
        : '';
      const pulseText = !hasCalories && hasPulse
        ? `<a href="${trainingsLink}" style="color: var(--color-primary, #FF8233); font-weight: 600; text-decoration: none;">${Number.isInteger(parsedPulse) ? parsedPulse : parsedPulse.toFixed(0)} уд/мин</a>`
        : '';
      const caloriesOrPulseText = caloriesText || pulseText;

      // Формирование текста в зависимости от дисциплины
      let prefix = '';
      if (discipline === 'Running') {
        prefix = 'Получена тренировка по бегу:';
      } else if (discipline === 'Walking') {
        prefix = 'Получена тренировка по ходьбе:';
      } else if (discipline === 'Cycling') {
        prefix = 'Получена велотренировка:';
      } else if (discipline === 'Swimming') {
        prefix = 'Получена тренировка по плаванию:';
      } else if (discipline === 'Skiing') {
        prefix = 'Получена тренировка по лыжам:';
      } else if (discipline === 'Dancing') {
        prefix = 'Получена тренировка по танцам:';
      } else if (discipline === 'Fitness') {
        prefix = 'Получена тренировка на гибкость и контроль:';
      } else if (discipline === 'Strength') {
        prefix = 'Получена силовая тренировка:';
      } else if (discipline === 'MartialArts') {
        prefix = 'Получена тренировка по боевым видам спорта:';
      } else if (discipline === 'Playing') {
        prefix = 'Получена тренировка по игровым видам спорта:';
      } else if (discipline === 'Extreme') {
        prefix = 'Получена тренировка по экстремальным видам спорта:';
      } else if (discipline === 'Outdoor') {
        prefix = 'Получена свободная тренировка:';
      }
      if (['Dancing', 'Fitness', 'Strength', 'MartialArts', 'Playing', 'Extreme', 'Outdoor'].includes(discipline)) {
        const parts = [durationText, caloriesOrPulseText].filter(Boolean);
        return parts.length ? `${prefix} ${parts.join(', ')}` : prefix;
      }
      if (!prefix) {
        prefix = 'Получена тренировка:';
      }

      // Для циклических видов спорта показываем расстояние, время и калории/пульс при наличии
      const cyclicParts = [distanceText, durationText, caloriesOrPulseText].filter(Boolean);
      if (cyclicParts.length) {
        return `${prefix} ${cyclicParts.join(', ')}`;
      }

      return prefix;
    },
    getFormattedDistance(value) {
      if (!value || !value.attributes) return '';
      const distance = parseInt(value.attributes.Distance, 10);
      const unit = distance >= 1000 ? 'км' : 'м';
      const formatted = distance >= 1000 ? Math.round(distance / 1000) : distance;
      if (value.attributes.Discipline === 'Walking') return `${formatted} ${unit} ходьба`;
      if (value.attributes.Discipline === 'Running') return `${formatted} ${unit} бег`;
      if (value.attributes.Discipline === 'Cycling') return `${formatted} ${unit} велозаезд`;
      if (value.attributes.Discipline === 'Swimming') return `${formatted} ${unit} плавание`;
      if (value.attributes.Discipline === 'Skiing') return `${formatted} ${unit} лыжи`;
      return '';
    },
    setActivities() {
      if (!this.participantStatistics) {
        this.statistics = [];
        return;
      }
      if (this.participantStatistics) {
        const activities = [];
        if (this.participantStatistics.Walking) {
          const walkingDistance = this.participantStatistics.Walking.distance;
          activities.push({
            icon: 'walking',
            value: String(walkingDistance >= 1000 ? Math.round(walkingDistance / 1000) : walkingDistance),
            subtitle: `${walkingDistance >= 1000 ? 'км' : 'м'}, ходьба`,
          });
        }
        if (this.participantStatistics.Running) {
          const runningDistance = this.participantStatistics.Running.distance;
          activities.push({
            icon: 'running',
            value: String(runningDistance >= 1000 ? Math.round(runningDistance / 1000) : runningDistance),
            subtitle: `${runningDistance >= 1000 ? 'км' : 'м'}, бег`,
          });
        }
        if (this.participantStatistics.Cycling) {
          const cyclingDistance = this.participantStatistics.Cycling.distance;
          activities.push({
            icon: 'cycling',
            value: String(cyclingDistance >= 1000 ? Math.round(cyclingDistance / 1000) : cyclingDistance),
            subtitle: `${cyclingDistance >= 1000 ? 'км' : 'м'}, вело`,
          });
        }
        if (this.participantStatistics.Swimming) {
          const swimmingDistance = this.participantStatistics.Swimming.distance;
          activities.push({
            icon: 'swimming',
            value: String(swimmingDistance >= 1000 ? Math.round(swimmingDistance / 1000) : swimmingDistance),
            subtitle: `${swimmingDistance >= 1000 ? 'км' : 'м'}, плавание`,
          });
        }
        if (this.participantStatistics.Skiing) {
          const skiingDistance = this.participantStatistics.Skiing.distance;
          activities.push({
            icon: 'skiing',
            value: String(skiingDistance >= 1000 ? Math.round(skiingDistance / 1000) : skiingDistance),
            subtitle: `${skiingDistance >= 1000 ? 'км' : 'м'}, лыжи`,
          });
        }
        this.statistics = activities;
      }
    },
    getNominationRating(item, isTeam = false) {
      if (!item) return [];

      const rating = [];
      const leaders = item && item.leaders ? item.leaders : [];
      for (let i = 0; i < leaders.length; i += 1) {
        const leader = leaders[i];
        if (!leader) continue;

        const it = {
          number: (leader.position || 0).toString(),
          name: isTeam ? (leader.teamName || '') : `${leader.lastName || ''} ${leader.firstName || ''}`.trim(),
          value: (leader.points || 0).toString(),
          current: isTeam ? leader.isCurrentTeam === true : leader.isCurrentUser === true,
        };
        rating.push(it);
      }
      return rating;
    },
    onShowRules(item) {
      if (!item) return;
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = false;
      this.rulesPrizesTabActive = 0;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title || '';
      this.rulesPrizesModal = true;
      window.location.hash = `#!showNomination=${item.nominationId || ''}&tab=0`;
    },
    onShowPrizes(item) {
      if (!item) return;
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = false;
      this.rulesPrizesTabActive = 1;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title || '';
      this.rulesPrizesModal = true;
      window.location.hash = `#!showNomination=${item.nominationId || ''}&tab=1`;
    },
    onShowRating(item, isTeam = false) {
      if (!item) return;
      this.rulesPrizesTabs[0].content = item.rules || '';
      this.rulesPrizesTabs[1].content = item.awards || '';
      this.rulesPrizesTabs[2].enabled = true;
      this.rulesPrizesTabActive = 2;
      this.rulesPrizesImage = this.getNominationImage(item);
      this.rulesPrizesTitle = this.getNominationDates(item);
      this.rulesPrizesSubtitle = item.title || '';
      this.rulesPrizesNominationId = item.nominationId || '';
      this.rulesPrizesIsTeam = isTeam;
      this.rulesPrizesModal = true;
      window.location.hash = `#!showNomination=${item.nominationId || ''}&tab=2`;
    },
    onRulesPrizesClosed() {
      window.location.hash = '';
      this.rulesPrizesModal = false;
    },
    getNominationDates(item) {
      if (!item) return '';
      const startDate = dayjs.utc(item.startDate);
      const finishDate = dayjs.utc(item.finishDate);
      if (startDate.isValid() && finishDate.isValid()) {
        return formatDateRange({ start: startDate, finish: finishDate, showYear: true });
      }
      return '';
    },
    getNominationImage(item) {
      if (!item || !item.images) return '';
      return this.$root.isDesktop ? item.images.desktop || '' : item.images.mobile || '';
    },
    isRatingTypeDisabled(index) {
      if (index === 0) {
        if (this.participantRatings ? this.participantRatings.length === 0 : true) return true;
      }
      if (index === 1) {
        if (this.isTeamRatingsDisabled()) return true;
        if (this.participantTeamRatings ? this.participantTeamRatings.length === 0 : true) return true;
      }
      return false;
    },
    onChangeNominationType(index) {
      if (this.selectedNominationType === index) return;
      const container = document.getElementById(this.nominationsSliderId);
      const prevHeight = container && container.offsetHeight ? container.offsetHeight : 0;
      this.nominationTypeSwitching = true;
      this.nominationsSwitchMinHeight = prevHeight;
      this.selectedNominationType = index;
      this.$nextTick(() => {
        setTimeout(() => {
          this.nominationTypeSwitching = false;
          this.nominationsSwitchMinHeight = 0;
        }, 450);
      });
    },
    isTeamRatingsDisabled() {
      return !this.isTeamSet && (this.options && this.options.disableTeamsForGuest === true);
    },

    onSliderIndexChaged() {
      scrollToId('dashboard-activity');
    },

    hasSameTimeAndType(operation1, operation2) {
      if (!operation1 || !operation2) {
        return false;
      }
      const isTraining = (op) => op.operationType === 'SportActivity' || op.operationType === 'SporadicActivity';
      if (!isTraining(operation1) || !isTraining(operation2)) {
        return false;
      }
      const date1 = dayjs(operation1.operationDate);
      const date2 = dayjs(operation2.operationDate);
      if (!date1.isValid() || !date2.isValid()) {
        return false;
      }
      return date1.isSame(date2, 'second');
    },
    filterOperationsByTime(operations) {
      const filteredOperations = [];
      let previousOperation = null;
      for (let i = 0; i < operations.length; i += 1) {
        const currentOperation = operations[i];
        if (previousOperation && this.hasSameTimeAndType(previousOperation, currentOperation)) {
          previousOperation.title += `, ${this.getFormattedDistance(currentOperation)}`;
        } else {
          filteredOperations.push(currentOperation);
          previousOperation = currentOperation;
        }
      }
      return filteredOperations;
    },
    getMapppedOperations(operations) {
      if (!operations) return [];
      const filteredOperations = this.filterOperationsByTime(operations);
      const days = [];
      let currentDay = { date: '', items: [] };
      let sportActivities = [];
      let lastDate = '';
      for (let i = 0; i < filteredOperations.length; i += 1) {
        const value = filteredOperations[i];
        const date = dayjs.utc(value.operationDate).local();
        if (!date.isValid()) continue;
        const formattedDate = date.format('D MMMM');
        const item = this.getMappedItem(value);
        const currentDate = date.format('YYYY-MM-DD');
        if (currentDate !== lastDate) {
          if (lastDate !== '') {
            days.push(currentDay);
          }
          currentDay = { date: formattedDate, items: [] };
          sportActivities = [];
        }
        if (value.operationType === 'SportActivity' || value.operationType === 'SporadicActivity') {
          const valueActivityId = value.activityId || (value.tags && value.tags.find((t) => t.key === 'ActivityId')?.value);
          const valueOperationId = value.operationId || value.eventId;
          const existingSportActivity = sportActivities.find((activity) => activity.time === item.time);
          const isSameActivity = existingSportActivity && (
            existingSportActivity.operationId === valueActivityId
            || existingSportActivity.activityId === valueOperationId
          );
          if (existingSportActivity && isSameActivity) {
            // Та же активность (SportActivity + SporadicActivity): не менять заголовок — оставляем дисциплинарный
          } else if (existingSportActivity) {
            existingSportActivity.activityTexts = existingSportActivity.activityTexts || [];
            existingSportActivity.activityTexts.push(item.activityText);
            const trainingsLink = '/my-settings/trainings';
            const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
            const texts = existingSportActivity.activityTexts;
            const allSame = texts.length > 0 && texts.every((t) => t === texts[0]);
            const formattedList = allSame ? `${texts[0]} (${texts.length})` : new Intl.ListFormat('ru').format(texts);
            existingSportActivity.title = `Получены новые тренировки: <a href="${this.isMobileApp ? mobileTrainingsLink : trainingsLink}">${formattedList}</a>`;
          } else {
            item.activityTexts = [item.activityText];
            // Одна тренировка — только дисциплинарный заголовок из getMappedItem. «Получены новые тренировки» только при нескольких за одно время.
            if (!item.title) {
              const trainingsLink = '/my-settings/trainings';
              const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
              item.title = `Получена тренировка: <a href="${this.isMobileApp ? mobileTrainingsLink : trainingsLink}">${item.activityText}</a>`;
            }
            currentDay.items.push(item);
            sportActivities.push(item);
          }
        } else {
          currentDay.items.push(item);
        }
        lastDate = currentDate;
      }
      if (currentDay.items.length > 0) {
        days.push(currentDay);
      }
      return days;
    },
    getMappedItem(value) {
      if (!value) return {};

      const item = {};
      // Нормализация без мутации параметра: если пришёл ответ с metadata/tags без attributes/operationType (сырой API)
      let resolvedAttributes = {};
      if (value.attributes && typeof value.attributes === 'object') {
        resolvedAttributes = value.attributes;
      } else if (Array.isArray(value.metadata)) {
        resolvedAttributes = Object.fromEntries(value.metadata.map((m) => [m.name, m.value]));
      }
      const resolvedOperationType = value.operationType != null
        ? value.operationType
        : (value.tags && value.tags.find((t) => t.key === 'OperationType')?.value);
      const val = { ...value, attributes: resolvedAttributes, operationType: resolvedOperationType };

      if (val.operationType === 'TeamParticipant') {
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        item.img = (val.attributes && val.attributes.TeamLogo) ? val.attributes.TeamLogo : '';
        if (val.attributes && val.attributes.StateOperation === 'Created') {
          item.title = `Вы присоединились к команде <a href="/my-team?title=Команда">${val.attributes.TeamName || ''}</a>`;
        } else {
          item.title = `Вы покинули команду <span class="team-out">${val.attributes.TeamName || ''}</span>`;
          item.isTaskRejected = true;
        }
        return item;
      }
      if (val.operationType === 'Purchase') {
        item.img = (val.attributes && val.attributes.ProductMobileImageUrl) ? val.attributes.ProductMobileImageUrl : '';
        item.isInternalImg = false;
        const rewardLink = `/market/reward?id=${val.attributes.PromotionId || ''}&title=${val.attributes.ProductName || ''}`;
        const mobileRewardLink = `/goPage?name=RewardDetails&path=${encodeURIComponent(rewardLink)}`;
        item.title = `Вы купили <a href="${this.isMobileApp ? mobileRewardLink : rewardLink}">${val.attributes.ProductName || ''}</a>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        item.coins = -Math.round(val.attributes.Amount || 0);
        return item;
      }
      if (val.operationType === 'ParticipantExercise') {
        // Данные упражнения могут приходить как в attributes, так и во вложенном объекте типа Exercise
        let exerciseAttributes = {};
        if (Array.isArray(val.objects)) {
          const exerciseObject = val.objects.find((o) => o && o.type === 'Exercise');
          if (exerciseObject && Array.isArray(exerciseObject.metadata)) {
            exerciseAttributes = Object.fromEntries(exerciseObject.metadata.map((m) => [m.name, m.value]));
          }
        }
        const exerciseTitle = (val.attributes && val.attributes.ExerciseTitle) || exerciseAttributes.ExerciseTitle || '';
        const exerciseImage = (val.attributes && val.attributes.ExerciseMobileImageUrl)
          || exerciseAttributes.ExerciseMobileImageUrl
          || exerciseAttributes.ExerciseDesktopImageUrl
          || '';

        const stateOperation = val.attributes.StateOperation;
        const isRejected = ['RejectedManually', 'Rejected'].includes(stateOperation);

        item.img = exerciseImage;
        item.isInternalImg = false;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');

        if (isRejected) {
          item.taskStatus = 'rejected';
          item.isTaskRejected = true;
          item.title = `Отменено задание <a href="#!showTask=${val.sourceId || ''}">${exerciseTitle}</a>`;
        } else if (stateOperation === 'Completed') {
          item.taskStatus = 'completed';
          item.title = `${this.getFormattedTaskState(val)} <a href="#!showTask=${val.sourceId || ''}&peId=${val.operationSourceId || ''}">${exerciseTitle}</a>`;
          const rewardNum = parseFloat(val.attributes.Reward);
          if (!Number.isNaN(rewardNum) && rewardNum > 0) {
            item.coins = `+${Math.round(rewardNum)}`;
          }
        } else {
          // Для Created и других статусов - без иконки, только текст
          item.title = `${this.getFormattedTaskState(val)} <a href="#!showTask=${val.sourceId || ''}&peId=${val.operationSourceId || ''}">${exerciseTitle}</a>`;
          if (stateOperation === 'AwaitingConfirmation') {
            item.taskStatus = 'checking';
          }
        }

        return item;
      }
      // SportActivity и SporadicActivity — одна и та же логика отображения (иконка по дисциплине, заголовок, награды)
      if (val.operationType === 'SportActivity' || val.operationType === 'SporadicActivity') {
        const discipline = val.attributes.Discipline || '';
        const activityIdFromTags = val.tags && val.tags.find((t) => t.key === 'ActivityId');
        const activityId = val.activityId || (activityIdFromTags && activityIdFromTags.value) || null;

        item.operationId = val.operationId || val.eventId;
        item.activityId = activityId;
        item.img = this.getTrainingIcon(discipline);
        item.isInternalImg = true;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');

        const trainingsLink = '/my-settings/trainings';
        const mobileTrainingsLink = `${trainingsLink}?title=Мой аккаунт`;
        const finalTrainingsLink = this.isMobileApp ? mobileTrainingsLink : trainingsLink;
        const activityTitle = this.getFormattedSportActivityTitle(val, finalTrainingsLink);

        const activityText = val.attributes.Distance ? this.getFormattedDistance(val) : '';
        item.activityText = activityText;
        item.title = activityTitle;

        const coinsValue = val.attributes.Reward
          || val.attributes.AccruedPoints
          || val.attributes.Coins
          || val.attributes.Amount
          || val.attributes.Points;
        if (coinsValue && parseFloat(coinsValue) > 0) {
          item.coins = `+${Math.round(parseFloat(coinsValue))}`;
        }

        const pointsValue = val.attributes.RatingPoints
          || val.attributes.Experience
          || val.attributes.XP
          || val.attributes.ExperiencePoints;
        if (pointsValue && parseFloat(pointsValue) > 0) {
          item.points = `+${Math.round(parseFloat(pointsValue))}`;
        }

        return item;
      }
      if (val.operationType === 'Achievement') {
        item.img = (val.attributes && val.attributes.ActiveIcon) ? val.attributes.ActiveIcon : '';
        item.isInternalImg = true;
        item.title = `Вы разблокировали достижение <b>${val.attributes.Title || ''}</b>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      if (val.operationType === 'ParticipantExperienceLevel') {
        item.img = ActivityCoverXP;
        item.isInternalImg = true;
        item.title = `Вы достигли <b>${val.attributes.Level || 0} ур.</b>`;
        item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
        return item;
      }
      item.img = '';
      item.isInternalImg = false;
      item.achievementType = '';
      item.title = '';
      item.time = dayjs.utc(val.operationDate).local().format('HH:mm');
      return item;
    },
    getFormattedTaskState(value) {
      if (!value || !value.attributes) return '';
      if (value.attributes.StateOperation === 'Created') return 'Вы начали задание';
      if (value.attributes.StateOperation === 'Completed') return 'Вы успешно выполнили задание';
      return '';
    },
    getActivity() {
      const id = this.$route.params.participantId;
      if (!id) return;
      this.activitySliderVisible = false;
      this.activitySliderHidden = true;
      this.loading = true;
      this.getActivityOperations(id)
        .then(() => {
          if (this.participantOperationshistory) {
            this.activities = this.getMapppedOperations(this.participantOperationshistory);
          }
          this.loading = false;
          this.$nextTick(() => {
            this.activitySliderVisible = true;
            setTimeout(() => {
              this.activitySliderHidden = false;
            }, 250);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStatistic() {
      this.participantId = this.$route.params.participantId;
      const id = this.participantId;
      if (!id) return Promise.resolve();

      const statisticPromise = this.getParticipantStatistic(id).then(() => {
        if (this.participantStatistics) {
          this.statistics = this.participantStatistics.statistics || [];
          this.setActivities();
        }
      });

      const stepsPromise = this.getParticipantSteps(id);
      const sportIndexPromise = this.getParticipantSportIndex(id);
      const achievementsPromise = this.getParticipantAchievements(id);

      return Promise.all([statisticPromise, stepsPromise, sportIndexPromise, achievementsPromise]);
    },
    pagePrev() {
      this.$router.push({ name: 'Participants' });
    },
    calculateAge(birthDate) {
      if (!birthDate) return '0 лет';

      try {
        const currentDate = new Date();
        const birthDateObj = new Date(birthDate);

        if (Number.isNaN(birthDateObj.getTime())) {
          return '0 лет';
        }

        let age = currentDate.getFullYear() - birthDateObj.getFullYear();
        const hasBirthdayPassed = currentDate.getMonth() > birthDateObj.getMonth() || (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() >= birthDateObj.getDate());
        if (!hasBirthdayPassed) {
          age -= 1;
        }

        if (age < 0) age = 0;

        let yearsStr = 'лет';
        if (age % 10 === 1 && age % 100 !== 11) {
          yearsStr = 'год';
        } else if (age % 10 >= 2 && age % 10 <= 4 && (age % 100 < 10 || age % 100 >= 20)) {
          yearsStr = 'года';
        }
        return `${age} ${yearsStr}`;
      } catch (error) {
        return '0 лет';
      }
    },
    onChangeTab(index) {
      this.loading = true;
      this.selectedTab = index;
      if (index === 0) {
        this.loadDataForFirstTab();
      } else if (index === 1) {
        this.loadDataForSecondTab();
      } else if (index === 2) {
        this.loadDataForThreeTab();
      }
    },
    loadDataForFirstTab() {
      this.getActivity();
    },
    loadDataForSecondTab() {
      const id = this.$route.params.participantId;
      if (!id) return;

      this.loading = true;
      this.ratingSliderVisible = false;
      this.ratingSliderHidden = true;

      Promise.all([
        this.getParticipantRatings(id),
        this.getParticipantTeamRatings(id),
      ])
        .then(() => {
          this.loading = false;
          this.selectedNominationType = this.hasPersonalRatings ? 0 : 1;
          this.$nextTick(() => {
            this.ratingSliderVisible = true;
            setTimeout(() => {
              this.ratingSliderHidden = false;
            }, 250);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    loadDataForThreeTab() {
      const id = this.$route.params.participantId;
      if (!id) {
        this.loading = false;
        return;
      }
      this.loading = true;
      Promise.all([
        this.getStatistic(),
        this.getParticipantDistance(id),
      ])
        .finally(() => {
          this.loading = false;
        });
    },
    isVisible(selectedTab) {
      return selectedTab === this.selectedTab;
    },
    getAvatarImage(avatar) {
      if (!avatar) return '';
      if (!avatar.type) return '';
      if (avatar.type === 'custom') {
        return avatar.url || '';
      }
      const found = Avatars.filter((i) => i.id === avatar.type);
      if (found.length === 0) return '';
      return found[0].img || '';
    },
    getParticipantData() {
      const { participantId } = this.$route.params;
      this.getParticipant(participantId)
        .then(() => {
          if (this.participant) {
            this.participantData = this.participant;
          }
        });
    },
    copyUrlToClipboard() {
      const temporaryElement = document.createElement('textarea');
      temporaryElement.value = this.url;
      document.body.appendChild(temporaryElement);
      temporaryElement.select();
      document.execCommand('copy');
      document.body.removeChild(temporaryElement);
    },
    showNomination(hash) {
      if (!hash[1]) {
        this.rulesPrizesModal = false;
        this.clearHash();
        return;
      }
      if (hash[1] === 'false') {
        this.rulesPrizesModal = false;
        this.clearHash();
        return;
      }

      let nominationId = hash[1] || '';
      if (!nominationId) {
        this.clearHash();
        return;
      }

      const tabIndex = nominationId.indexOf('&tab');
      let tab = '0';
      if (tabIndex >= 0) {
        nominationId = nominationId.slice(0, tabIndex);
        tab = hash[2] || '0';
      }
      if (!['0', '1', '2'].includes(tab)) tab = '0';

      let values = [];
      if (this.selectedNominationType === 0) values = [...this.participantRatings];
      else if (this.selectedNominationType === 1) values = [...this.participantTeamRatings];

      if (values.length > 0) {
        const item = values.find((i) => i.nominationId === nominationId);
        if (!item) return;
        if (tab === '0') this.onShowRules(item);
        else if (tab === '1') this.onShowPrizes(item);
        else if (tab === '2') this.onShowRating(item, this.selectedNominationType === 1);
      }
    },
    showParticipant(hash) {
      if (hash[1] === 'true') this.paticipantModal = true;
      else {
        this.paticipantModal = false;
        this.clearHash();
      }
    },
    clearHash() {
      setTimeout(() => { window.location.hash = ''; }, 100);
    },
  },
  mounted() {
    window.addEventListener('hashchange', this.onHashChange);
    this.onHashChange();
    this.getProfile()
      .then(() => {
        this.getParticipantData();
        this.loadDataForFirstTab();
        this.getIndexes();
      });
    this.getBalance();
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./ParticipantItem";
  .activity__loader {
    min-height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .activity__slider,
  .nominations__slider {
    max-height: 1000px;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  .activity__slider--hidden {
    max-height: 0;
  }
</style>
